import { SYNC_KEY_TERCEROS_FINCAS } from "../../../constantes";
import { FincasPlataformaService } from "../../generated/grpc/plataforma_terceros_fincas_pb";
import { FincaListItemResponse } from "../../response/terceros/FincaListItemResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { nombreTipoFinca } from "./FincaGetByIdService";

/** Fincas activas de un cliente (`FincasPlataformaService.ListByCliente`, gRPC), en memoria por cliente. */
export class FincaListByClienteIdService extends ServiceGetListBase<FincaListItemResponse> {
  private static readonly _instances = new Map<string, FincaListByClienteIdService>();

  /** Singleton por cliente. */
  static instance(clienteId: string): FincaListByClienteIdService {
    if (!this._instances.has(clienteId))
      this._instances.set(clienteId, new FincaListByClienteIdService(clienteId));
    return this._instances.get(clienteId)!;
  }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey: string;

  /** Guarda el cliente dueño y arma la clave de deduplicación. */
  private constructor(private readonly _clienteId: string) {
    super();
    this.syncKey = `${SYNC_KEY_TERCEROS_FINCAS}/byClienteId/${_clienteId}`;
  }

  /** gRPC-Web: fincas con relación activa y no eliminadas, por nombre. */
  protected async fetchItems(): Promise<FincaListItemResponse[]> {
    const response = await grpcCall(() =>
      grpcClient(FincasPlataformaService).listByCliente({ clienteId: this._clienteId }),
    );
    return response.items.map((f) => ({
      id: f.id,
      isEliminado: false,
      nombreFinca: f.nombreFinca,
      tipoFinca: f.tipoFinca,
      tipo: nombreTipoFinca(f.tipoFinca),
      isGanaderia: f.tipoFinca === 1,
      municipioNombre: f.municipioNombre ?? null,
      hectareasFinca: f.hectareasFinca,
    }));
  }
}
